import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_6538_28847)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = { id: "clip0_6538_28847" }
const _hoisted_9 = ["width", "height", "fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'effort',
  props: {
  color: {
    type: String as PropType<string>,
    default: "currentColor",
  },
  width: {
    type: Number as PropType<number>,
    default: 14,
  },
  height: {
    type: Number as PropType<number>,
    default: 14,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M1.16081 4.375H0.577474C0.422764 4.375 0.274391 4.43646 0.164995 4.54585C0.0555988 4.65525 -0.00585937 4.80362 -0.00585938 4.95833L-0.00585937 9.04167C-0.00585937 9.19638 0.0555988 9.34475 0.164995 9.45415C0.274391 9.56354 0.422764 9.625 0.577474 9.625H1.16081C1.23816 9.625 1.31235 9.59427 1.36705 9.53957C1.42174 9.48488 1.45247 9.41069 1.45247 9.33333V4.66667C1.45247 4.58931 1.42174 4.51513 1.36705 4.46043C1.31235 4.40573 1.23816 4.375 1.16081 4.375Z",
        fill: __props.color
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M4.07682 3.20801H2.61849C2.46378 3.20801 2.31541 3.26947 2.20601 3.37886C2.09661 3.48826 2.03516 3.63663 2.03516 3.79134V10.208C2.03516 10.3627 2.09661 10.5111 2.20601 10.6205C2.31541 10.7299 2.46378 10.7913 2.61849 10.7913H4.07682C4.15418 10.7913 4.22836 10.7606 4.28306 10.7059C4.33776 10.6512 4.36849 10.577 4.36849 10.4997V3.49967C4.36849 3.42232 4.33776 3.34813 4.28306 3.29344C4.22836 3.23874 4.15418 3.20801 4.07682 3.20801Z",
        fill: __props.color
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M13.4121 4.375H12.8288C12.7514 4.375 12.6772 4.40573 12.6225 4.46043C12.5678 4.51513 12.5371 4.58931 12.5371 4.66667V9.33333C12.5371 9.41069 12.5678 9.48488 12.6225 9.53957C12.6772 9.59427 12.7514 9.625 12.8288 9.625H13.4121C13.5668 9.625 13.7152 9.56354 13.8246 9.45415C13.934 9.34475 13.9954 9.19638 13.9954 9.04167V4.95833C13.9954 4.80362 13.934 4.65525 13.8246 4.54585C13.7152 4.43646 13.5668 4.375 13.4121 4.375Z",
        fill: __props.color
      }, null, 8, _hoisted_5),
      _createElementVNode("path", {
        d: "M11.3652 3.20801H9.9069C9.82955 3.20801 9.75536 3.23874 9.70066 3.29344C9.64596 3.34813 9.61523 3.42232 9.61523 3.49967V10.4997C9.61523 10.577 9.64596 10.6512 9.70066 10.7059C9.75536 10.7606 9.82955 10.7913 9.9069 10.7913H11.3652C11.5199 10.7913 11.6683 10.7299 11.7777 10.6205C11.8871 10.5111 11.9486 10.3627 11.9486 10.208V3.79134C11.9486 3.63663 11.8871 3.48826 11.7777 3.37886C11.6683 3.26947 11.5199 3.20801 11.3652 3.20801Z",
        fill: __props.color
      }, null, 8, _hoisted_6),
      _createElementVNode("path", {
        d: "M5.24479 6.125H8.74479C8.74479 6.125 9.03646 6.125 9.03646 6.41667V7.58333C9.03646 7.58333 9.03646 7.875 8.74479 7.875H5.24479C5.24479 7.875 4.95312 7.875 4.95312 7.58333V6.41667C4.95312 6.41667 4.95312 6.125 5.24479 6.125Z",
        fill: __props.color
      }, null, 8, _hoisted_7)
    ]),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", _hoisted_8, [
        _createElementVNode("rect", {
          width: __props.width,
          height: __props.height,
          fill: __props.color
        }, null, 8, _hoisted_9)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})